import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { DataService } from 'services/data.service';
import { SignPriorities } from 'domain-models/SignPriorities';
import { environment } from '../../environments/environment';

@Injectable()
export class SignPrioritiesService extends DataService<SignPriorities> {
	constructor(http: Http) {
		super(environment.host + 'SignPriorities', http);
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/services/sign-priorities/sign-priorities.service.ts